import httpManager from "@/app/shared/utils/httpManager";

export async function fetchBotAIExpenses({ filters, page = 1 } = {}) {
  // const limit = TABLE_PAGE_SIZE;
  // const offset = (page - 1) * TABLE_PAGE_SIZE;

  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const channel_customer = filters?.channel_customers
    ? JSON.stringify(filters.channel_customers)
    : "";

  const url = `/billing/charges/botAi/`;
  // const query = `?limit=${limit}&offset=${offset}&channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;
  const query = `?channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.get(`${url}${query}`);
  return response.data;
}

export async function downloadBotAIExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const channel_customer = filters?.channel_customers
    ? JSON.stringify(filters.channel_customers)
    : "";

  const url = `/billing/charges/botAi/`;
  const query = `?channel_customer=${channel_customer}&start_date=${startDate}&end_date=${endDate}&export=excel`;

  const response = await httpManager.getBlob(`${url}${query}`);
  return response;

}
